import type { TeamMember } from '@twlvxtwlv/types'

export const teamMembers: ReadonlyArray<TeamMember> = [
  {
    jobTitle: 'CEO & Co-Founder',
    name: 'Jan Denecke',
    description: 'Jan is a legal expert in copyright & media law and a blockchain enthusiast.',
    avatarImage: '/images/team-avatars/jan_denecke_avatar.jpg',
    hoverImage: '/images/team-hover-images/jan_denecke_hover.jpg',
  },
  {
    jobTitle: 'CXO & Co-Founder',
    name: 'Philipp Köhn',
    description:
      'Philipp is an experience professional and blockchain veteran. With a strong network in the creative agency and blockchain world.',
    avatarImage: '/images/team-avatars/philipp_koehn_avatar.jpg',
    hoverImage: '/images/team-hover-images/philipp_koehn_hover.jpg',
  },
  {
    jobTitle: 'General Manager & Co-Founder',
    name: 'Michael Eisele',
    description:
      'Michael is a well-versed entrepreneur in the music industry and brings in an international network of collaborators.',
    avatarImage: '/images/team-avatars/michael_eisele_avatar.jpg',
    hoverImage: '/images/team-hover-images/michael_eisele_hover.jpg',
  },
  {
    jobTitle: 'HR, Finance & Administration Manager',
    name: 'Julia Dürr',
    description:
      'Julia oversees our day-to-day operations and feeds the team with new talents. With a background in legal and accounting she‘s the managing team‘s right hand woman.',
    avatarImage: '/images/team-avatars/julia_duerr_avatar.jpg',
    hoverImage: '/images/team-hover-images/julia_duerr_hover.jpg',
  },
  {
    jobTitle: 'Production Director of Business Operations',
    name: 'Marcus Kregel',
    description:
      'Marcus brings in 10+ years of experience as creative manager and producer for music, culture, brand and digital experiences.',
    avatarImage: '/images/team-avatars/marcus_kregel_avatar.jpg',
    hoverImage: '/images/team-hover-images/marcus_kregel_hover.jpg',
  },
  {
    jobTitle: 'Head of Finance',
    name: 'Stephan König',
    description:
      'Our Head of Finance, Stephan, brings over a decade of experience in running finances for major players in the music industry and finds himself super excited about every twelve x twelve drop.',
    avatarImage: '/images/team-avatars/stephan_koenig_avatar.jpg',
    hoverImage: '/images/team-hover-images/stephan_koenig_hover.jpg',
  },
  {
    jobTitle: 'Director of Communications',
    name: 'Julia Rommel',
    description:
      'Julia comes with 15+ years experience as PR strategist and communications consultant in the international music-, media arts-, tech- and corporate-world. Linking pop and high-end culture she creates innovative communication strategies and new perspectives in thought leadership and events',
    avatarImage: '/images/team-avatars/julia_rommel_avatar.jpg',
    hoverImage: '/images/team-hover-images/julia_rommel_hover.jpg',
  },
  {
    jobTitle: 'Director of Strategy',
    name: 'Stefan Schieber',
    description:
      'Meet our Director of Strategy, Stefan the mastermind who blends a lifelong obsession with music and creativity with an uncanny ability to wrangle data, creating business strategies that hit all the right notes.',
    avatarImage: '/images/team-avatars/stefan_schieber_avatar.jpg',
    hoverImage: null,
  },
  {
    jobTitle: 'Head of Product',
    name: 'Johannes Epp',
    description:
      'Introducing our Head of Product, Johannes, the unstoppable force who expertly analyzes, orchestrates projects, and delivers with lightning speed—a true maestro in the world of product management.',
    avatarImage: '/images/team-avatars/johannes_epp_avatar.jpg',
    hoverImage: '/images/team-hover-images/johannes_epp_hover.jpg',
  },
  {
    jobTitle: 'Senior Creative Producer',
    name: 'Patrick Janz',
    description:
      'Patrick is a seasoned veteran with over 12 years of experience in crafting captivating experiences that transcend the boundaries of the live and digital realms—making reality cooler than fiction, one project at a time.',
    avatarImage: '/images/team-avatars/patrick_janz_avatar.jpg',
    hoverImage: '/images/team-hover-images/patrick_janz_hover.jpg',
  },
  {
    jobTitle: 'Production Manager',
    name: 'Daniel Ciekalski',
    description:
      'Daniel is a Popakademie Baden-Württemberg student, NFT-enthusiast and wrote his master thesis about the usage of NFTs in the music industry',
    avatarImage: '/images/team-avatars/daniel_ciekalski_avatar.jpg',
    hoverImage: '/images/team-hover-images/daniel_ciekalski_hover.jpg',
  },
  {
    jobTitle: 'Product Manager',
    name: 'Marc Beniashvili',
    description:
      'Marc leads product design and development. With experience working in marketing and NFTs, he brings constructive insight and expert know-how.',
    avatarImage: '/images/team-avatars/marc_beniashvili_avatar.jpg',
    hoverImage: '/images/team-hover-images/marc_beniashvili_hover.jpg',
  },
  {
    jobTitle: 'Multimedia Designer',
    name: 'Rahul Sharma',
    description:
      'Get ready to meet our extraordinary Multimedia Designer, Rahul, a relentless innovator who fearlessly challenges the status quo, shaping new frontiers of design perception and interaction. Brace yourself for a visual revolution like no other.',
    avatarImage: '/images/team-avatars/rahul_sharma_avatar.jpg',
    hoverImage: '/images/team-hover-images/rahul_sharma_hover.jpg',
  },
  {
    jobTitle: 'Community Manager',
    name: 'Anna Lisa Shirin Haeder',
    description:
      'Meet our Community Manager, Anni, a rising star with a powerful voice that not only resonates through her music but also helps us find resonance and awareness within the relevant communities we serve.',
    avatarImage: '/images/team-avatars/anna_lisa_shirin_haeder_avatar.jpg',
    hoverImage: '/images/team-hover-images/anna_lisa_shirin_haeder_hover.jpg',
  },
  {
    jobTitle: 'Senior Frontend Developer',
    name: 'Christoph Gampe',
    description:
      'Say hello to our lightning-fast Senior Front End Developer, Christoph whose superpower lies in seamlessly transforming click dummies into barrier-free, exceptional user experiences for our Marketplace and all our future applications. Get ready for a digital journey that defies expectations and sets new standards.',
    avatarImage: '/images/team-avatars/christoph_gampe_avatar.jpg',
    hoverImage: null,
  },
  {
    jobTitle: 'Sales and A&R Manager',
    name: 'Eric Burton',
    description:
      'With 30+ years working in the music & entertainment industry, Eric is an experienced professional and active player in both the German and international scenes.',
    avatarImage: '/images/team-avatars/eric_burton_avatar.jpg',
    hoverImage: '/images/team-hover-images/eric_burton_hover.jpg',
  },
]
